module.exports = new __parcel__URL__("peter.a62a828b.jpeg").toString();